import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.css";
import Navbar from "../../components/molecules/Navbar";
import Footer from "../../components/molecules/Footer";
import Button from "../../components/atoms/Button";
import Label from "../../components/atoms/Label";
import InputText from "../../components/atoms/InputText";
import { DataContext } from "../../context/DataContext";
import { DataContextType } from "../../types/DataContextType";
import { createNach } from "../../services/sanctions";
import { useLocation ,useNavigate} from "react-router-dom";
// import { process.env.REACT_APP_DASHBOARD_URL } from "../../utils/keys";
import { MandateType } from "../../utils/types";
import { ApplicantStage } from "../../utils/applicationStage";

let Digio;

function DigioMandate() {
  const [mandateStatus, setMandateStatus] = useState<MandateType>({});

  const { userId, applicationId } = useContext(DataContext) as DataContextType;

  const [radioSelectedAccount, setRadioSelectedAccount] = useState("SAVINGS");
  const [radioSelectedMandate, setRadioSelectedMandate] = useState("NET_BANKING");

  const [state, setState] = useState({
    accountNumber: "",
    ifscCode: "",
  });
  const navigate=useNavigate();
  const location = useLocation();
  console.log("location state data:", location?.state?.data);

  const rawData = sessionStorage.getItem("data")
  
  let [userData, setUserData] = useState<{
      application:string,
      dob:string,
      applicationId: string;
      userId: string;
      email: string;
      panId: string;
      dateOfBirth: string;
      instituteId: string;
      firstName: string;
      lastName: string;
      mobile: string;
      course: string;
      fees: number;
      studentName: string;
      instituteName: string;
      redirectUrl: string;
      channelId: number;
      flow:string;
    }>({
      application:'',
      applicationId: "",
      userId: "",
      instituteId: "",
      firstName: "",
      lastName: "",
      panId: "",
      dateOfBirth: "",
      dob:'',
      email: "",
      mobile: "",
      course: "",
      fees: 0,
      studentName: "",
      instituteName: "",
      redirectUrl: "",
      channelId: 0,
      flow:''
    });

  useEffect(() => {
      if (rawData) {
        try {
          const jsonData = atob(rawData)
          setUserData(JSON.parse(jsonData));
        } catch (error) {}
      }
  
    }, []);

  const getAppId = () => {
    // Prefer userData values first (from session) then fall back to location.state
    if (userData?.applicationId) return userData.applicationId;
    if (userData?.application) return userData.application;
    const loc = (location as any)?.state?.data;
    if (loc) return loc?.existing ? loc?.applicationId : loc?.application || "";
    return "";
  };

  const getUserId = () => {
    // Prefer userData value first then fall back to location.state
    if (userData?.userId) return userData.userId;
    const loc = (location as any)?.state?.data;
    return loc?.userId || "";
  };

  const { accountNumber, ifscCode } = state;

  const handleChange = (key: any, val: any) => {
    setState({ ...state, [key]: val });
  };

  //   digio sdk begin

  const fetchJsFromCDN = (src : any, externals: string[]) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.setAttribute("src", src);
      script.addEventListener("load", () => {
        resolve(
          externals.map((key: any) => {
            const ext = window[key];
            if (typeof ext === "undefined") {
              console.warn(`No external named '${key}' in window`);
            }
            return ext;
          })
        );
      });
      script.addEventListener("error", reject);
      document.body.appendChild(script);
    });
  };

  

  

  // https://app.digio.in/sdk/v11/digio.js
  // https://ext-gateway.digio.in/sdk/v11/digio.js

  async function initiateDigio() {
    // console.log("returnUrltoken:", returnUrltoken);
    fetchJsFromCDN("https://app.digio.in/sdk/v11/digio.js", ["Digio"]).then(
      async (digio: any) => {
        Digio = digio[0];
        
        let digioInstance = new Digio({
          environment: "production",
          callback: async function (response : any) {
            console.log("call back res",response)
            if (response.hasOwnProperty("error_code")) {
              console.error("Error occurred:", response.message);
              //added 
              // navigate("/error-page", { state: { errorMessage: response.message } });
              alert(response.message)
              //end
              window.location.reload()
              return;
            }
            console.log("Signing completed successfully:", response.digio_doc_id);

            // const requestOptions = {
            //   method: "POST",
            //   headers: {
            //     "Content-Type": "application/json",
            //     Authorization: `Bearer ${authToken.value}`,
            //   },
            //   body: JSON.stringify({
            //     account_number: accountNumber,
            //     mandate_id: response.digio_doc_id,
            //     ifsc_code: ifscCode,
            //   }),
            // };

            // const result = await fetch(
            //   `${process.env.REACT_APP_DASHBOARD_URL}/mandate/store`,
            //   requestOptions
            // );
            // const storeResponse = await result.json();
            // console.log("Mandate stored successfully:", storeResponse);

            // navigate("/mandate");
            navigate("/pf-collection", {
              state: { data: location?.state?.data },
            });
          },
          // logo: "https://www.mylogourl.com/image.jpeg",
          theme: {
            primaryColor: "#AB3498",
            secondaryColor: "#000000",
          },
          is_iframe: true,
         
          dg_preferred_auth_type: radioSelectedMandate || "debit",
          // Is_redirection_approach : true,
          // redirect_url : `${process.env.REACT_APP_URL}/${returnUrltoken}`
          // redirect_url : `${process.env.REACT_APP_URL}/thank-you`
        });

        // const requestOptions = {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken.value}`,
        //   },
        //   body: JSON.stringify({
        //     accountNumber,
        //     accountType: radioSelectedAccount,
        //     customerMobile: location?.state?.data?.mobile,
        //     ifsc: ifscCode,
        //     // customerName: "Dummy",
        //     authType: radioSelectedMandate,
        //     userId: location?.state?.data?.userId,
        //     applicationId: location?.state?.data?.existing ?  location?.state?.data?.applicationId : location?.state?.data?.application,
        //   }),
        // };

        // const result = await fetch(
        //   `${process.env.REACT_APP_DASHBOARD_URL}/digio-emandates/register-emandate`,
        //   requestOptions
        // );
        // const response = await result.json();
        // console.log("Mandate registration response:", response);
        const response = await getRazorpayUrl()

        if (response?.mandate_id) {
          digioInstance.init();
          digioInstance.submit(response.mandate_id, authToken.mob, response.access_token.id);
          // digioInstance.submit(response.mandate_id, authToken.mob);
        }
        else {
          alert(response?.message)
        }
      }
    );
  }



  // digio sdk ends

  async function getRazorpayUrl() {
    if (!accountNumber || !ifscCode) {
      return { message: "Enter all the fields" };
    }

    const applicationId = getAppId();
    const userIdLocal = getUserId();
    const loc = (location as any)?.state?.data;
    const mobile = loc?.mobile || userData?.mobile || "";

    const response = await createNach({
      accountNumber: accountNumber,
      accountType: radioSelectedAccount,
      ifscCode: ifscCode,
      mandateType: radioSelectedMandate,
      userId: userIdLocal,
      applicationId: applicationId,
      mobile: mobile,
    });
    return response;

    // window.open(response?.data?.url, "_blank", "noopener,noreferrer");
  }

   const [authToken, setAuthToken] = useState({
    mob: "",
    value: "",
  });
const authData = sessionStorage.getItem("data");
  useEffect(() => {
    const loc = (location as any)?.state?.data;

    let applicationId = getAppId();
    let userIdLocal = getUserId();
    let mobile = loc?.mobile || userData?.mobile || "";

    if ((!applicationId || !userIdLocal || !mobile) && rawData) {
      try {
        const parsed = JSON.parse(atob(rawData));
        if (!applicationId) applicationId = parsed?.applicationId || parsed?.application || "";
        if (!userIdLocal) userIdLocal = parsed?.userId || "";
        if (!mobile) mobile = parsed?.mobile || "";
      } catch (e) {
      }
    }

    if (!applicationId && !userIdLocal && !mobile) {
      console.warn("Skipping generate-token: missing mobile/userId/applicationId", {
        applicationId,
        userId: userIdLocal,
        mobile,
      });
      return;
    }

    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/generate-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: mobile,
        userId: userIdLocal,
        applicationId: applicationId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAuthToken({
          mob: mobile,
          value: data.data,
        });
      })
      .catch((err) => console.error("generate-token error", err));
  }, [location, userData]);

  useEffect(() => {
    const applicationId = getAppId();
    if (!applicationId) return;

    let isReload = false;
    try {
      const navEntries = (performance as any).getEntriesByType
        ? (performance as any).getEntriesByType("navigation")
        : null;
      if (navEntries && navEntries.length > 0) {
        isReload = navEntries[0].type === "reload";
      } else if ((performance as any).navigation) {
        isReload = (performance as any).navigation.type === 1; 
      }
    } catch (e) {
      isReload = false;
    }

    const hasUserData = !!(userData?.applicationId || userData?.application);
    const hasLocationState = !!(location as any)?.state?.data;

    if (!isReload && !(hasUserData && !hasLocationState)) return;

    fetch(
      `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${encodeURIComponent(
        applicationId
      )}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.data?.stage) {
          switch (res?.data?.stage) {
            case ApplicantStage.PFCollections:
              navigate("/pf-collection", {
                state: { data: (location as any)?.state?.data },
              });
              break;
            case ApplicantStage.Disbursed:
              navigate("/disbursed-page", {
                state: { data: (location as any)?.state?.data },
              });
              break;
          }
        }
      })
      .catch((err) => console.log(err));
  }, [location?.state?.data, userData.applicationId, userData.application, navigate]);

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.container}>
          <div className={styles.childContainer}>
            <div className={styles.inputField}>
              <Label text="Account Number" />
              <InputText
                placeholder="Account Number"
                type="number"
                value={accountNumber}
                changeHandler={(e) =>
                  handleChange("accountNumber", e.target.value)
                } 
                // disabled
              />
            </div>

            <div className={styles.inputField}>
              <Label text="IFSC Code" />
              <InputText
                placeholder="IFSC Code"
                type="text"
                value={ifscCode}
                changeHandler={(e) => handleChange("ifscCode", e.target.value)} 
                // disabled
              />
            </div>
            <div className={styles.inputField}>
              <Label text="Account Type" />
              <div
                onChange={(event) =>
                  setRadioSelectedAccount(
                    (event.target as HTMLInputElement).value
                  )
                }
                defaultValue="SAVINGS"
              >
                <input
                  type="radio"
                  value="SAVINGS"
                  name="student"
                  checked={radioSelectedAccount === "SAVINGS"}
                />{" "}
                Savings <br />
                <input
                  type="radio"
                  value="CURRENT"
                  name="student"
                  checked={radioSelectedAccount === "CURRENT"}
                  // disabled
                />{" "}
                Current
              </div>
            </div>
            <div className={styles.inputField}>
              <Label text="How do you want to authenticate your account?" />
              <div
                onChange={(event) =>
                  setRadioSelectedMandate(
                    (event.target as HTMLInputElement).value
                  )
                }
                defaultValue="NET_BANKING"
              >
                <input
                  type="radio"
                  value="NET_BANKING"
                  name="Net Banking"
                  checked={radioSelectedMandate === "NET_BANKING"}
                />{" "}
                Net Banking <br />
                <input
                  type="radio"
                  value="DEBIT_CARD"
                  name="Debit Card"
                  checked={radioSelectedMandate === "DEBIT_CARD"}
                />{" "}
                Debit Card
              </div>
            </div>
            <Button 
            // insureFin={location?.state?.data?.channelId === 5}
              onPress={() => {
                initiateDigio();
                // getRazorpayUrl();
              }}
              text="SUBMIT"
            />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default DigioMandate;
